import { StackDivider, VStack } from '@chakra-ui/react';
import { IProfileLink } from '../../config/profileLinks';
import ProfileLink from '../profileLink/ProfileLink';

interface Props {
    profileLinks: IProfileLink[];
    closeModal: () => void;
}

export default function ProfileLinks({ profileLinks, closeModal }: Props) {
    return (
        <VStack divider={<StackDivider borderColor="#2f3138" />} spacing="10px" align="stretch">
            {profileLinks.map((profileLink) => (
                <ProfileLink
                    profileLink={profileLink}
                    closeModal={closeModal}
                    isActive={profileLink.to === '/orders'}
                />
            ))}
        </VStack>
    );
}
